
namespace Gamification.Gamification {
    export class EstensioniColumns {
        static columnsKey = 'Gamification.Estensioni';
    }
}